import { render, staticRenderFns } from "./Server_error.vue?vue&type=template&id=a166c486&scoped=true"
import script from "./Server_error.vue?vue&type=script&lang=js"
export * from "./Server_error.vue?vue&type=script&lang=js"
import style0 from "./Server_error.vue?vue&type=style&index=0&id=a166c486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a166c486",
  null
  
)

export default component.exports